<template>
  <div class="Parlement">
    <div class="Parlement__txt" v-html="msg"/>
  </div>
</template>

<script>

export default {
  name: 'Parlement',
  data: () => ({
    msg: 'Experience Parlement'
  }),

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.checkVisibility)
    window.removeEventListener('focus', this.focus)
    window.removeEventListener('blur', this.blur)
    window.removeEventListener('beforeunload', this.beforeunload)
  },

  mounted(){

    this.$nextTick(()=>{
      document.addEventListener('visibilitychange', this.checkVisibility)
      window.addEventListener('focus', this.focus)
      window.addEventListener('blur', this.blur)
      window.addEventListener('beforeunload', this.beforeUnload)
      this.msg += '</br>mounted . '
    })
  },

  methods: {

    checkVisibility() {
      this.msg += 'checkVisibility = '+ document.visibilityState + ' . '
    },
    focus() {
      this.msg += `<span class="focus">focus . </span>`
    },
    blur() {
      this.msg += `<span class="blur">blur . </span></br>`
    },
    beforeUnload() {
      this.msg += `<span class="blur">beforeUnload . </span></br>`
    },


  }

}
</script>

<style lang="stylus"> 

@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'

.Parlement 
  position absolute 
  top 0 
  left 0
  width 100vw
  height 100vh
  color black
  font-size 14px
  padding 24px

  &__txt 
    width 80vw
    color black
    min-height 60px
    line-height 28px

.focus
  color green
  font-weight bold
 
.blur
  color red
  font-weight bold

</style>




